import React from 'react';
import { Redirect } from 'react-router';
import { paramsToObjects } from '../../../components/common/create-params';
import { ROUTE_PATH } from '../../../routes/paths';

// Member pages read the member from the query string, so a direct visit or bookmark has nothing to load.
export const requireMember = (Page: React.FC): React.FC => {
  const RequireMember: React.FC = () =>
    paramsToObjects()?.callerRoleId ? <Page /> : <Redirect to={ROUTE_PATH.MEMBERS} />;
  return RequireMember;
};
